<template>
  <!-- 收款方-交易流水 -->
  <content-container :table-row-count="tableData.length">
    <search-container>
      <search-col>
        <el-input v-model="params.tpOrderNo" placeholder="易宝订单编号" clearable @keydown.enter="doSearch" />
      </search-col>
      <search-col>
        <el-input v-model="params.orderNo" placeholder="平台订单编号" clearable @keydown.enter="doSearch" />
      </search-col>
      <search-col>
        <el-input v-model="params.payee" placeholder="收款方名称" clearable @keydown.enter="doSearch" />
      </search-col>
      <search-col>
        <el-select
          v-model="params.txnType"
          placeholder="记账方式"
          clearable
          style="width: calc(100% - 5px)"
        >
          <el-option :label="yibaoTxnTypeConfig[EYibaoTxnType.SETTLE]" :value="EYibaoTxnType.SETTLE" />
          <el-option v-if="source=='company'" :label="yibaoTxnTypeConfig[EYibaoTxnType.SPLIT_PAY]" :value="EYibaoTxnType.SPLIT_PAY" />
          <el-option v-if="source=='company'" :label="yibaoTxnTypeConfig[EYibaoTxnType.SELF_KEEP]" :value="EYibaoTxnType.SELF_KEEP" />
          <el-option v-if="source=='company'" :label="yibaoTxnTypeConfig[EYibaoTxnType.REFUND]" :value="EYibaoTxnType.REFUND" />
          <el-option :label="yibaoTxnTypeConfig[EYibaoTxnType.WITHDRAW]" :value="EYibaoTxnType.WITHDRAW" />
          <el-option v-if="source!=='company'" :label="yibaoTxnTypeConfig[EYibaoTxnType.SETTLE_REFUND]" :value="EYibaoTxnType.SETTLE_REFUND" />
          <el-option v-if="source=='company'" :label="yibaoTxnTypeConfig[EYibaoTxnType.REVERSAL]" :value="EYibaoTxnType.REVERSAL" />
          <el-option :label="yibaoTxnTypeConfig[EYibaoTxnType.TRANSFER]" :value="EYibaoTxnType.TRANSFER" />
        </el-select>
      </search-col>
      <search-col v-if="source=='company'">
        <el-select
          v-model="params.acctType"
          placeholder="账户类型"
          clearable
          style="width: calc(100% - 5px)"
        >
          <el-option :label="yibaoAcctTypeConfig[EYibaoAcctType.SPLIT]" :value="EYibaoAcctType.SPLIT" />
          <el-option :label="yibaoAcctTypeConfig[EYibaoAcctType.BALANCE]" :value="EYibaoAcctType.BALANCE" />
        </el-select>
      </search-col>
      <search-col>
        <el-select
          v-model="params.txnDir"
          style="width: calc(100% - 5px)"
          placeholder="交易方式"
          clearable
        >
          <el-option :label="yibaoTxnDirConfig[EYibaoTxnDir.IN]" :value="EYibaoTxnDir.IN" />
          <el-option :label="yibaoTxnDirConfig[EYibaoTxnDir.OUT]" :value="EYibaoTxnDir.OUT" />
        </el-select>
      </search-col>

      <search-col>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD"
          :default-time="defaultTimeFormat"
          style="width: calc(100% - 4px)"
          start-placeholder="交易时间(起)"
          end-placeholder="交易时间(止)"
          @keydown.enter="doSearch"
        />
      </search-col>

      <template #buttons>
        <el-button @click="resetForm">
          <svg-icon icon="tabler:refresh" />重置
        </el-button>
        <el-button class="mr-[4px]" type="primary" @click="doSearch">
          <svg-icon icon="lucide:search" />查询
        </el-button>
      </template>
    </search-container>

    <div class="flex justify-between items-center">
      <el-button class="mb-[16px]" type="primary" @click="exportFile">
        <svg-icon icon="lucide:square-arrow-out-up-right" />导出
      </el-button>

      <div>
        <span>入账合计(元)：{{ formatMoneyString(creditTotal) }}</span>
        <span class="ml-4">出账合计(元)：{{ formatMoneyString(debitTotal) }}</span>
      </div>
    </div>

    <!-- 表格数据 -->
    <el-table v-loading="loading" class="normal-table" :border="true" :scrollbar-always-on="true" :max-height="maxHeight" :data="tableData">
      <el-table-column align="left" prop="tpOrderNo" label="易宝订单编号" show-overflow-tooltip :min-width="120">
        <template #default="scope">
          {{ scope.row.tpOrderNo || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="orderNo" label="平台订单编号" show-overflow-tooltip :min-width="120" />
      <el-table-column align="left" prop="payer" label="付款方名称" show-overflow-tooltip :min-width="160" />
      <el-table-column align="left" prop="payee" label="收款方名称" show-overflow-tooltip :min-width="160" />
      <el-table-column align="left" prop="txnType" label="记账方式" show-overflow-tooltip :width="80">
        <template #default="scope">
          {{ yibaoTxnTypeConfig[scope.row.txnType] }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="txnDir" label="交易方式" show-overflow-tooltip :width="80">
        <template #default="scope">
          {{ yibaoTxnDirConfig[scope.row.txnDir] }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="acctType" label="账户类型" show-overflow-tooltip :width="100">
        <template #default="scope">
          {{ yibaoAcctTypeConfig[scope.row.acctType] }}
        </template>
      </el-table-column>
      <el-table-column align="right" prop="initAmt" label="期初金额(元)" show-overflow-tooltip :width="105">
        <template #default="scope">
          {{ formatMoneyString(scope.row.initAmt) || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="right" prop="txnAmt" label="交易金额(元)" show-overflow-tooltip :width="105">
        <template #default="scope">
          {{ formatMoneyString(scope.row.txnAmt) || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="right" prop="finalAmt" label="期末金额(元)" show-overflow-tooltip :width="105">
        <template #default="scope">
          {{ formatMoneyString(scope.row.finalAmt) || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="txnTime" label="交易时间" show-overflow-tooltip :width="170" />
      <el-table-column
        align="center"
        prop="actions"
        label="交易回单"
        :width="80"
      >
        <template #default="scope">
          <el-button
            v-if="scope.row.txnRcptUrl"
            type="primary"
            link
            @click="handleSearchReceipt(scope.row)"
          >
            查看
          </el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部分页 -->
    <template #footer>
      <el-pagination
        v-if="total > 0"
        v-model:current-page="params.page"
        v-model:page-size="params.size"
        :class="{ 'fix-fixed-footer': fixedFooter }"
        :page-sizes="[defaultPageSize, 25, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        @size-change="onSizeChange"
        @current-change="onCurrentPageChange"
      />
    </template>
  </content-container>
</template>

<script setup lang="ts">
import { ref, reactive, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { SvgIcon } from '@vue3/components';
import { getFomattedTimeRange, formatMoneyString, downloadFile } from '@core/tools';
import { useRoute } from 'vue-router';
import { ContentContainer, SearchContainer, SearchCol, useCardTableHeightFix, queryTransactionRecord, exportTxnRecords, queryTxnRecordSummary } from '../../../..';
import { ITransactionRecord, ITransactionRecordParams, yibaoTxnTypeConfig, EYibaoTxnType, yibaoAcctTypeConfig, EYibaoAcctType, yibaoTxnDirConfig, EYibaoTxnDir } from '../../../../types/yibao-manage';

defineOptions({ name: 'TransactionFlow' });
const route = useRoute();

const defaultTimeFormat = computed (() => getFomattedTimeRange());

const yibaoId = computed(() => route.query.yibaoId as string);
const source = computed(() => route.query.from || 'company');

const loading = ref(false);
const tableData = ref<ITransactionRecord[]>([] as ITransactionRecord[]);
const defaultPageSize = 12;
const total = ref(0);

const creditTotal = ref<number>();
const debitTotal = ref<number>();

const dateRange = ref([]);

const params = reactive<ITransactionRecordParams>({
  merchantId: Number(yibaoId.value),
  page: 1,
  size: defaultPageSize,
});

const { maxHeight, fixedFooter } = useCardTableHeightFix(total);

async function fetchData() {
  loading.value = true;

  try {
    const { data, total: all } = await queryTransactionRecord({
      ...params,
      merchantId: Number(yibaoId.value),
      txnTimeStart: dateRange.value[0],
      txnTimeEnd: dateRange.value[1],
    }, source.value == 'company');

    tableData.value = data;
    total.value = all;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

function resetForm() {
  dateRange.value = [];

  for (const key in params) {
    if (!['page', 'size'].includes(key)) {
      params[key] = '';
    }
  }
}

function onSizeChange(size: number) {
  params.size = size;
  params.page = 1;
  fetchData();
  fetchSum();
}

function onCurrentPageChange(page: number) {
  params.page = page;
  fetchData();
  fetchSum();
}
function doSearch() {
  params.page = 1;
  fetchData();
  fetchSum();
}

async function exportFile() {
  try {
    const { buffer, fileName } = await exportTxnRecords({
      ...params,
      merchantId: Number(yibaoId.value),
      txnTimeStart: dateRange.value[0],
      txnTimeEnd: dateRange.value[1],
    }, source.value == 'company');

    downloadFile(buffer, fileName, null);
    ElMessage.success('导出成功');
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

function handleSearchReceipt(row: ITransactionRecord) {
  if (!row.txnRcptUrl) return ElMessage.error('凭证不存在');
  
  window.open(row.txnRcptUrl);
}

async function fetchSum() {
  try {
    const { inAmt, outAmt } = await queryTxnRecordSummary({
      ...params,
      merchantId: Number(yibaoId.value),
      txnTimeStart: dateRange.value[0],
      txnTimeEnd: dateRange.value[1],
    });

    creditTotal.value = inAmt;
    debitTotal.value = outAmt;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

fetchSum();
fetchData();

</script>
